import Vue from 'vue';
import Vuex from 'vuex';
import LoginUser from './modules/login_user';
import Users from './modules/users';
import Moneybox from './modules/moneybox';
import Corporation from './modules/corporation';
import Reports from './modules/reports';
import Segments from './modules/segments';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    LoginUser,
    Users,
    Moneybox,
    Corporation,
    Reports,
    Segments
  }
})
